"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsPageBottom = void 0;
const react_1 = require("react");
const useIsPageBottom = () => {
    const [isPageBottom, setIsPageBottom] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handleScroll = () => {
            const totalPageHeight = document.body.scrollHeight;
            const scrollPoint = Math.ceil(window.scrollY + window.innerHeight);
            const currentIsPageBottom = scrollPoint >= totalPageHeight;
            setIsPageBottom((prevState) => prevState === currentIsPageBottom ? prevState : currentIsPageBottom);
        };
        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return isPageBottom;
};
exports.useIsPageBottom = useIsPageBottom;
//# sourceMappingURL=index.js.map